import { defineComponent as _defineComponent } from 'vue'
import store from "@/store"
import { computed, ref, watch, WritableComputedRef } from "vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'filter-dialog',
  setup(__props) {

const active = computed(() => {
    return store.state.app!.filter.active
})
const title = computed(() => {
    return store.state.app!.filter.title
})
const text = computed(() => {
    return store.state.app!.filter.message
})
/*
const linefilter:WritableComputedRef<string> = computed({
    get():string {
        return store.state.app!.linefilter
    },
    set(val: string) {
        store.state.app!.linefilter = val
    }
})
*/
const linefilter1 = ref("")
const vehiclefilter1 = ref("")
const closeDialog = () => {
    ///store.state.app!.linefilter = linefilter
    //console.log(linefilter1.value)
    store.state.app!.linefilter = linefilter1.value
    store.state.app!.vehiclefilter = vehiclefilter1.value
    store.state.app!.filter.active = false
}
watch(active,(val) => {
    if (val) {
        linefilter1.value = store.state.app!.linefilter
        vehiclefilter1.value = store.state.app!.vehiclefilter
    }
})

return { __sfc: true,active, title, text, linefilter1, vehiclefilter1, closeDialog }
}

})